import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const booking = (intl) => {
  return (
    <a
      href={intl.formatMessage({ id: 'link.bookingterms', defaultMessage: '/en/terms-booking' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="booking terms"
        defaultMessage="Booking Terms"
      />
    </a>
  );
};

const payment = (intl) => {
  return (
    <a
      href={intl.formatMessage({ id: 'link.mangopayterms', defaultMessage: 'https://mangopay.com/terms-and-conditions/payment-services' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="Payment Terms"
        defaultMessage="Payment Terms"
      />
    </a>
  );
};

const service = (intl) => {
  return (
    <a
      href={intl.formatMessage({ id: 'link.terms', defaultMessage: '/en/terms' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="Terms of Service"
        defaultMessage="Terms of Service"
      />
    </a>
  );
};

const rental = (intl) => {
  return (
    <a
      href={intl.formatMessage({ id: 'link.generalterms', defaultMessage: '/en/terms-letting' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="Rental Terms"
        defaultMessage="Rental Terms"
      />
    </a>
  );
};

const insurance = (intl) => {
  return (
    <a
      href={intl.formatMessage({ id: 'link.omocomterms', defaultMessage: '/public/Stugknuten-Forsakringsvillkor-1.4.pdf' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage
        id="Insurance Terms"
        defaultMessage="Insurance Terms"
      />
    </a>
  );
};

const AcceptTerms = ({ withRentalTerms }) => {
  const intl = useIntl();

  if (withRentalTerms) {
    return (
      <FormattedMessage
        id="acceptTermsRental"
        defaultMessage="I accept the {rental}, {service}, {booking} and {payment}."
        values={{
          service: service(intl),
          rental: rental(intl),
          booking: booking(intl),
          payment: payment(intl),
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id="acceptTerms"
      defaultMessage="I accept the {service}, {booking} and {payment}."
      values={{
        booking: booking(intl),
        service: service(intl),
        payment: payment(intl),
      }}
    />
  );
};

const AcceptTermsWithInsurance = () => {
  const intl = useIntl();

  return (
    <FormattedMessage
      id="acceptTermsRentalInsurance"
      defaultMessage="I accept the {service}, {booking}, {payment}, {rental} and {insurance}."
      values={{
        service: service(intl),
        rental: rental(intl),
        booking: booking(intl),
        insurance: insurance(intl),
        payment: payment(intl),
      }}
    />
  );
};

AcceptTerms.propTypes = {
  withRentalTerms: PropTypes.bool,
};

export default AcceptTerms;
export { AcceptTermsWithInsurance, insurance };
